import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const benefits = ['Plan diario de solo 15 minutos.', 'Reconexión con tu hijo sin gritos ni culpas.', 'Scripts exactos de qué decir en cada situación.', 'Funciona aunque tu hijo no quiera cooperar.', '+500 madres ya recuperaron la conexión.'];
export function BenefitsBullets() {
  return <section className="py-8 md:py-12 bg-maternal-cream" data-id="element-1">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl p-6 md:p-8 shadow-md border border-maternal-amber/20" data-id="element-3">
          <div className="space-y-4 mb-6" data-id="element-4">
            {benefits.map((text, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.08
          }} className="flex items-center gap-3" data-id="element-5">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-6">
                  <Check className="w-4 h-4 text-green-600" data-id="element-7" />
                </div>
                <span className="text-base md:text-lg text-maternal-brown font-medium" data-id="element-8">
                  {text}
                </span>
              </motion.div>)}
          </div>
          <div className="text-center" data-id="element-9">
            <CTAButton text="EMPEZAR AHORA" data-id="element-10" />
          </div>
        </motion.div>
      </div>
    </section>;
}